import { memo } from 'react'

type DotTextProps = {
  color: string
  children: React.ReactNode
}

export const DotText = memo(({ color, children }: DotTextProps) => (
  <div className='flex items-center justify-start leading-4 [&_span]:ms-1 [&_span]:text-colorTextQuaternary'>
    <span className='me-[0.5em] rounded-full p-1' style={{ backgroundColor: color }} />
    {children}
  </div>
))
